import { HvacVersion } from 'src/modules/hvac/types/HvacVersion';

export const HVAC_VERSION_LIST: ReadonlyArray<HvacVersion> = [
  HvacVersion.ACTUAL,
  HvacVersion.FUTURE,
];
